<template>
  <div v-if="visible" class="wallet-modal" @click.self="close">
    <div class="wallet-box">
      <div class="wallet-title">Connect Wallet</div>
      <button class="wallet-btn" @click="connect">🦊 MetaMask</button>
    </div>
  </div>
</template>

<script>
import { connectWallet } from '@/web3/connect'

export default {
  computed: {
    visible() { return this.$store.state.walletVisible }
  },
  methods: {
    close() { this.$store.commit('SET_WALLET_VISIBLE', false) },
    async connect() { await connectWallet(this.$store); this.close() }
  }
}
</script>

<style>
.wallet-modal {
  position: fixed; inset: 0; z-index: 9999;
  background: rgba(0,0,0,.7); display: flex; align-items: center; justify-content: center;
  backdrop-filter: blur(10px);
}
.wallet-box { width: 300px; border-radius: 20px; padding: 24px; background: #17181f; }
.wallet-btn { width: 100%; height: 48px; cursor: pointer; }
</style>
